import { Col } from '@landsbankinn/ui-kit';
import { useEffect, useState } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import {
  type Account,
  type ScopeData,
  ScopeDataFormat,
} from '../../../state/server';
import { useConsentClientContext } from '../State/consentClientState';
import { getAvailableAccounts } from '../utils';
import { AccountSelection } from './AccountSelection';
import { AccountsTable } from './AccountsTable';
import { FooterWithButtons } from './FooterWithButtons';

export function ListView(props: {
  data: ScopeData;
  title?: string;
  description?: string;
  previousTitle: string;
  nextTitle: string;
  isLastView: boolean;
  onPrevious: () => void;
  onNext: () => void;
}) {
  const { isMobile } = useScreenSize();
  const [consentClient] = useConsentClientContext();
  const format = props.data.format;

  const [accounts, setAccounts] = useState<Account[]>([]);

  useEffect(() => {
    if (consentClient.scope) {
      setAccounts(
        getAvailableAccounts(props.data, consentClient.scope?.accounts),
      );
    }
  }, [consentClient.scope, props.data]);

  return (
    <Col
      paddingTop="20"
      paddingHorizontal={isMobile ? '36' : undefined}
      grow="1"
    >
      <Col grow="1">
        {format &&
          format === ScopeDataFormat.Account &&
          accounts.length > 0 && (
            <>
              {!isMobile && (
                <AccountsTable
                  availableAccounts={accounts}
                  selectedAccountIds={[]}
                  choiceType={props.data.choiceType}
                  title={props.title}
                  description={props.description}
                />
              )}
              {isMobile && (
                <Col>
                  <AccountSelection
                    availableAccounts={accounts}
                    selectedAccountIds={[]}
                    choiceType={props.data.choiceType}
                  />
                </Col>
              )}
            </>
          )}
      </Col>
      <FooterWithButtons
        previousTitle={props.previousTitle}
        nextTitle={props.nextTitle}
        isConfirm={props.isLastView}
        onNext={() => {
          props.onNext();
        }}
        onPrevious={() => {
          props.onPrevious();
        }}
      />
    </Col>
  );
}
